import { MutationCache, QueryClient } from '@tanstack/react-query'

/**
 * Application QueryClient.
 *
 * The MutationCache hook is the single, global wiring for the login-streak
 * chip: backend-side, ANY successful mutating request marks the day as active
 * (StreakActivityListener on kernel.request), so instead of sprinkling
 * `invalidateQueries(['streak'])` into every useMutation of the app, we
 * invalidate once here — the lantern lights up right after the first
 * successful action of the day, whatever it is.
 */
export function createAppQueryClient(): QueryClient {
  const queryClient: QueryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
    mutationCache: new MutationCache({
      // Runs after each mutation's own onSuccess — the closure over
      // `queryClient` is safe: it only fires once the client exists.
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: ['streak'] })
      },
    }),
  })

  return queryClient
}
